import { Navigate } from 'react-router-dom';
import React from 'react';
import { useUser } from '../Context/UserContext';
import { PERMISSIONS } from '../Utils/permissions';

const ProtectedRoute = ({ children }) => {
  const { user, loading, permissions } = useUser();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  // Needs basic admin-panel access (staff)
  if (!permissions?.[PERMISSIONS.ADMIN_PANEL_ACCESS]) {
    return <Navigate to="/admin/login" replace state={{ reason: 'no_admin_access' }} />;
  }

  return children;
};

export default ProtectedRoute;
